import { messageKeyPrefix } from "../utils/message.util";
import User from "../models/User";

export const apiPrefix = "/api/v1";
export const httpMethodType = {
  get: 'GET',
  post: 'POST',
  put: 'PUT',
  delete: 'DELETE'
};

export class ConnectionService {
  constructor() {
    this.data = null;
    this.error = { code: null, message: null };
    this.defaultHeaders = { 'Content-Type': 'application/json; charset=utf-8' };
    this.httpMethodType = httpMethodType;
  }

  cleanDataAndError() {
    this.data = null;
    this.error = null;
  }

  async sendRequest(url, config = {}, responseDirectly = false, responseType = null) {
    if (process.env.NODE_ENV === 'development') {
      url = `${process.env.REACT_APP_BASE_URL}${url}`;
    }

    if (config.params) {
      // Default is encoded
      let paramString = '?' + new URLSearchParams(config.params).toString();
      if (!config.encode) {
        paramString = '?' + Object.keys(config.params).map(key => `${key}=${config.params[key]}`).join('&');
      };

      url += paramString
    }

    let headers = this.defaultHeaders;
    if (config.headers) {
      headers = config.headers;
    }

    User.token && (headers["authorization"] = `Bearer ${User.token['access_token']}`);

    const response = await fetch(url, {
      method: config.method ? config.method : this.httpMethodType.get,
      headers,
      body: config.body ? config.body : null,
    });

    if (responseDirectly) {
      try {
        if (responseType === 'text') {
          return await response.text();
        } else {
          return await response.json();
        }
      } catch (err) {
        return err;
      }
    } else {
      const data = await response.json();

      if (!data.error) {
        this.data = data;
        this.error = { code: null, message: null };
      } else {
        this.error.originCode = data.error.code;
        this.error.code = `${messageKeyPrefix.e.s}${data.error.code}`;
        this.error.message = data.error.message;
      }
    }
  }

  hasError() {
    return !!this.error.code;
  }
}